import { Box, IconButton } from "@mui/material";
import CaseAutocomplete from "components/CaseAutocomplete";
import { useParams } from "react-router-dom";
import { P } from "theme/typography";
import theme, { EllipsisSX } from "theme";
import { Close } from "@mui/icons-material";
import useSearchParamsWithUpdate from "helpers/hooks/useSearchParamsWithUpdate";
import { CASE_QP_SEPARATOR, extractCaseIdAndName } from "Backend";

const CaseFilter = () => {
  const { searchParams, updateParam } = useSearchParamsWithUpdate();
  const { lensId } = useParams();
  const numberLensId = parseInt(lensId || "");
  const cases = searchParams.getAll("cases");

  return (
    <>
      {!isNaN(numberLensId) && (
        <CaseAutocomplete
          label="Case"
          clearOnChange
          lensId={numberLensId}
          onChange={(selectedCase) => {
            let paramCases;
            if (selectedCase) {
              paramCases = (cases || []).slice();
              paramCases.push(`${selectedCase.caseId}${CASE_QP_SEPARATOR}${selectedCase.claimantName}`);
            }
            updateParam("cases", Array.from(new Set(paramCases || cases)));
          }}
        />
      )}
      {cases.length > 0 ? (
        <Box>
          {cases.map((c) => (
            <Box
              sx={{
                p: 0.5,
                backgroundColor: theme.palette.patternSecondary.main,
                borderRadius: "4px",
                display: "flex",
                alignItems: "center",
                mb: 0.5,
              }}
              key={c}>
              <P variant="subtitle2" sx={{ color: "white", ...EllipsisSX }}>
                {extractCaseIdAndName(c)[1]}
              </P>
              <Box sx={{ flexGrow: 1 }} />
              <IconButton
                size="small"
                sx={{ color: "white" }}
                onClick={() => {
                  const foundIndex = cases.findIndex((caseParam) => caseParam === c);
                  const newCases = cases.slice();

                  if (foundIndex > -1) {
                    newCases.splice(foundIndex, 1);
                  }
                  updateParam("cases", newCases);
                }}>
                <Close />
              </IconButton>
            </Box>
          ))}
        </Box>
      ) : (
        <></>
      )}
    </>
  );
};

export default CaseFilter;
